import { render, staticRenderFns } from "./OrganizationPage.vue?vue&type=template&id=691c30dc&scoped=true"
import script from "./OrganizationPage.vue?vue&type=script&setup=true&lang=js"
export * from "./OrganizationPage.vue?vue&type=script&setup=true&lang=js"
import style0 from "./OrganizationPage.vue?vue&type=style&index=0&id=691c30dc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../account/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "691c30dc",
  null
  
)

export default component.exports